import { render, staticRenderFns } from "./BasicsCard.vue?vue&type=template&id=ea80dcc0&scoped=true&"
import script from "./BasicsCard.vue?vue&type=script&lang=js&"
export * from "./BasicsCard.vue?vue&type=script&lang=js&"
import style0 from "./BasicsCard.vue?vue&type=style&index=0&id=ea80dcc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea80dcc0",
  null
  
)

export default component.exports